import { useState, useEffect } from 'react';
import ListPromo from '../components/ListPromo';
import InfiniteScroll from 'react-infinite-scroll-component';
import CardLoading from '../components/CardLoading';
import { Button, Container, Row } from 'reactstrap';
import { useLocation, useHistory } from 'react-router-dom';
import Filter from '../components/Filter';
import NotFound from '../components/NotFound';
import SlidingHighlights from '../components/SlidingHighlights';
import SlidingHero from '../components/SlidingHero';
import { Master } from '../data';
import jsonQuery from 'json-query';
import Paginator from '../helper/Paginator';
import _ from 'lodash';
import GetCurrentLang from '../helper/GetCurrentLang';
declare global {
  interface Window {
    dataLayer: any;
  }
}

const Index = () => {
  const [items, setItems] = useState({
    data: [],
    page: 1,
  });

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  const query = useQuery();
  const history = useHistory();

  const queryCategory = query.get('category');
  const queryCity = query.get('city');
  const querySort: string | null = query.get('sort');
  const queryKeyword = query.get('search');

  const [categoryFilter, setCategoryFilter] = useState<any[]>(queryCategory !== null ? queryCategory.split(',') : []);
  const [cityFilter, setCityFilter] = useState<any[]>(queryCity !== null ? queryCity.split(',') : []);
  const [sortFilter, setSortFilter] = useState<string>(querySort !== null ? querySort : 'asc');
  const [querySearch, setQuerySearch] = useState(queryKeyword !== null ? queryKeyword : '');
  const [hasMore, setHasMore] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const per_page = 8;

  let location = useLocation();

  interface PaginationTypes {
    data: any[];
    next_page: number | null;
    page: number | null;
    per_page: number | null;
    total: number | null;
    total_pages: number;
  }
  const { categories, cities } = Master;

  let qString = function (filter: string[], type: string): string {
    let catString: string = '';
    filter.map((cat) => {
      const taxonomy = type === 'category' ? categories : cities;
      let filter: any = taxonomy.filter((category) => category.slug === cat);
      catString += `${type === 'category' ? 'category~' : 'city~'}${filter[0].name}|`;
    });
    return catString.slice(0, -1);
  };

  let qSearch = function () {
    const { promo } = Master;
    let result: any[] = [];
    let data = GetCurrentLang() === 'id' ? promo.id : promo.en;
    data.forEach(function (o: any) {
      o.title && o.title.toLowerCase().indexOf(querySearch.toLowerCase()) >= 0 && result.push(o);
    });
    return result;
  };

  const filter = qString(categoryFilter, 'category') + (categoryFilter.length > 0 && cityFilter.length > 0 ? '&' : '') + qString(cityFilter, 'city');

  const JSONq = jsonQuery(`promo[${GetCurrentLang()}][**][*${filter}]`, {
    data: Master,
    allowRegexp: true,
  });

  const pagination: PaginationTypes = Paginator({
    items: _.orderBy(querySearch === '' ? JSONq.value : qSearch(), ['title'], 'asc'),
    current_page: items.page,
    per_page_items: 12,
  });

  useEffect(() => {
    // Fetch data on load and filter changed
    fetchMoreData();
  }, [queryCategory, queryCity, querySearch]);

  function resetItems() {
    setItems({
      data: [],
      page: 1,
    });
    setHasMore(true);
  }

  function removeFilter() {
    setCategoryFilter([]);
    setCityFilter([]);
  }

  const fetchMoreData = () => {
    const total_pages = pagination.total_pages;
    if (items.page === total_pages) {
      setHasMore(false);
    }
    if (total_pages > 0) {
      setTimeout(
        () => {
          setItems((prevItems) => {
            let item: any = items.page > 1 ? prevItems : { data: [] };
            const newData = item.data.concat(pagination.data);
            return {
              data: newData,
              page: prevItems.page + 1,
            };
          });
        },
        items.page > 1 ? 1000 : 0
      );
      setNotFound(false);
    } else {
      setNotFound(true);
    }
  };

  const filterCategory = (category: any) => {
    const checkIfExist = categoryFilter.includes(category);
    if (checkIfExist) {
      setCategoryFilter(categoryFilter.filter((e) => e !== category));
    } else {
      setCategoryFilter([...categoryFilter, category]);
    }
  };

  const filterCity = (city: any) => {
    const checkIfExist = cityFilter.includes(city);
    if (checkIfExist) {
      setCityFilter(cityFilter.filter((e) => e !== city));
    } else {
      setCityFilter([...cityFilter, city]);
    }
  };

  const filterSubmit = () => {
    setQuerySearch('');
    resetItems();
    history.push({
      pathname: '/',
      search: `${categoryFilter.length > 0 ? `category=${categoryFilter.join()}` : ''}${cityFilter.length > 0 ? `&city=${cityFilter.join()}` : ''}`,
    });
  };

  const searchSubmit = (query: string) => {
    resetItems();
    removeFilter();
    setQuerySearch(query === null ? '' : query);
    history.push({
      pathname: '/',
      search: query === null ? '' : `search=${query}`,
    });
  };

  const resetFilter = () => {
    resetItems();
    setQuerySearch('');
    removeFilter();
    history.push({
      pathname: '/',
      search: '',
    });
  };

  function TotalLoader() {
    const getWindowWidth = window.innerWidth;
    let total = per_page;
    if (getWindowWidth > 768 && getWindowWidth < 992) {
      total = 2;
    } else if (getWindowWidth < 768) {
      total = 1;
    }
    return total;
  }

  const loading = (
    <Row>
      {Array.apply(0, Array(TotalLoader())).map(function (x, i) {
        return (
          <div className="ColPromo" key={i}>
            <CardLoading />
          </div>
        );
      })}
    </Row>
  );

  const isHomePage = () => {
    return location.pathname === '/' && location.search === '';
  };

  return (
    <>
      <div className="bg-light-blue pt-4">
        <Container>
          <div className="d-flex flex-column flex-lg-row justify-content-lg-between align-items-lg-end header-index">
            <h2 className="mb-4 mb-lg-0 mt-0">Promo BCA QRIS</h2>
            <Filter
              sortFilter={sortFilter}
              setSortFilter={setSortFilter}
              filterCategory={filterCategory}
              categoryFilter={categoryFilter}
              filterCity={filterCity}
              cityFilter={cityFilter}
              filterSubmit={filterSubmit}
              resetFilter={resetFilter}
              searchSubmit={searchSubmit}
              queryKeyword={querySearch}
            />
          </div>
        </Container>
      </div>
      <div className="white-section">
        <Container>
          {isHomePage() && (
            <>
              <SlidingHero />
              <SlidingHighlights resetFilter={resetFilter} setCategoryFilter={setCategoryFilter} />
            </>
          )}
          {!notFound ? (
            <InfiniteScroll dataLength={items.data.length} next={fetchMoreData} hasMore={hasMore} loader={loading} scrollThreshold={0.7}>
              <ListPromo {...items} />
            </InfiniteScroll>
          ) : (
            <NotFound />
          )}
          {!isHomePage() && (
            <div className="text-center">
              <Button color="primary" onClick={() => resetFilter()}>
                Kembali ke Halaman Promo
              </Button>
            </div>
          )}
        </Container>
      </div>
    </>
  );
};

export default Index;
